import cheader from '@/components/header/index.vue'

export default {
	name: 'register2',
	data() {
		return {
			active: 3,
		}
	},
	methods: {
		
	},
	components: {
		cheader
	}
}


// WEBPACK FOOTER //
// ./src/views/user/register2/index.js